// extracted by mini-css-extract-plugin
module.exports = {"textContainer":"RadioChannelCardContent_textContainer__akE7s","ongoing":"RadioChannelCardContent_ongoing__dkxru","upcoming":"RadioChannelCardContent_upcoming__8SIU7"};